<template lang="pug">
    div(:class="{'min-h-[447px] md:min-h-[491px]':reserveSpace}")
        div(v-if="recommendationsData" class="py-8 md:py-12")
            div(v-if="recommendationsData.title" class="text-gray-darkest text-2xl font-bold leading-5 pb-8 lg:text-3xl") {{ recommendationsData.title }}
            Carousel(containerClass="gap-x-3")
                div(
                    v-for="(item, index) in recommendationsData.results"
                    :key="`carousel-product-${item.productLineName}-${index}`"
                    class="w-[275px]"
                )
                    Listing(:listing="item" :isCarousel="true" :isSchemaOn="false")
</template>

<script>
import { mapState } from 'vuex'
import Carousel from '@/components/carousel'
import Listing from '@/components/productListing'

export default {
    name: 'CarouselProduct',
    components: { Carousel, Listing },
    props: {
        productType: {
            type: String,
            default: 'similar',
            validator: (value) => {
                const acceptedValues = ['similar', 'related', 'recent', 'recommended']
                return acceptedValues.includes(value)
            },
        },
        reserveSpace: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState('recommendations', {
            recommendationsData(state) {
                return state[this.productType]
            },
        }),
    },
}
</script>
